import { isDevMode } from '../../isDevMode';

export const debug = (...args: unknown[]): void => {
  if (isDevMode()) {
    console.log(...args);
  }
};

export default debug;
